import { Component, OnInit } from '@angular/core';
import { TrackingDataService } from 'app/d2z/service/tracking-data.service';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'd2z-transit-time-report',
  templateUrl: './transit-time-report.component.html',
  styleUrls: ['./transit-time-report.component.css']
})
export class TransitTimeReportComponent implements OnInit {
response: any;
airwayBill :String;
scan: String;
  constructor(  public trackingDataService : TrackingDataService,
          private spinner: NgxSpinnerService,
) { }

  ngOnInit() {
  this.scan = "5ULB";
  }

downloadReport(){
	console.log(this.airwayBill);
	console.log(this.scan);
this.spinner.show();
 this.trackingDataService.transitReport(this.airwayBill , (resp) => {
          this.spinner.hide();

       this.response = resp;

          var dataList = [];
  var fileName = '';
          fileName = "Transit Report"+"_"+this.airwayBill;
        var options = { 
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: true, 
          useBom: true,
          headers: [ 
            "hawb",
            "Carrier",
            "Customer Name",
            "Customer Address",
            "City",
            "State",
            "Postcode",
            "Weight",
            "Total Value",
            "Injected Date",
            "Status",
            "Status Date",
            "Delivered",
            "Transit",
            "MAWB"
          ]
        };
        for(var n in this.response){
          var data = this.response[n];
             var transitData = (
                  transitData={},
                  transitData['hawb']= data != null ? data['hawb']: '', transitData,                
                  transitData['carrier']= data != null ? data['carrier']: '', transitData,
                  transitData['customerName']= data != null ? data['customerName']: '', transitData,       
                  transitData['customerAddress']= data != null ? data['customerAddress']: '',transitData,                         
                  transitData['city']= data != null ? data['city']: '', transitData,
                  transitData['state']= data != null ? data['state']: '', transitData,
                  transitData['postcode']= data != null ? data['postcode']: '', transitData,
                  transitData['weight']= data != null ? data['weight']: '', transitData,
                  transitData['totalValue']= data != null ? data['totalValue']: '', transitData,
                  transitData['injectedDate']= data != null ? data['injectedDate']: '', transitData,
                  transitData['status']= this.scan==='FirstScan' ? data['firstScan']: data['latestStatus'], transitData,
                  transitData['statusDate']= this.scan==='FirstScan' ? data['firstScanTimestamp']: data['latestStatusDate'], transitData,
                  transitData['delivered']= data != null ? data['delivered']: '', transitData,
                  transitData['transit']= data != null ? data['transit']: '', transitData,
                  transitData['mawb']= data != null ? data['mawb']: '', transitData



                
              );
           dataList.push(transitData);
        }
      new Angular2Csv(dataList, fileName, options);        

        });
     
}
}



// WEBPACK FOOTER //
// ./src/app/d2z/views/superuser-level/reports/transit-time-report/transit-time-report.component.ts